import { render, staticRenderFns } from "./delete-lookup-table.vue?vue&type=template&id=66e6ba69"
import script from "./delete-lookup-table.vue?vue&type=script&lang=js"
export * from "./delete-lookup-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports